import { GET_PACKAGE_BOXES_REQUEST, GET_PACKAGE_BOXES_FAILURE, GET_PACKAGE_BOXES_SUCCESS } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getPackageBoxesReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PACKAGE_BOXES_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case GET_PACKAGE_BOXES_REQUEST:
            return Object.assign({}, state);
        case GET_PACKAGE_BOXES_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        default:
            return state;
    }
};
export default getPackageBoxesReducer;
